var visuallyImpairedSettings = (function ($) {

    visuallyImpairedSettings = function (options) {
        var that = this;

        // DOM
        that.$html = $('html');
        that.drawer_html = options['drawer_html'];

        // CONST
        that.cookie_name = 'visually_impaired';
        
        that.class = {
            switch_on: 'js-visually-impaired-on',
            switch_off: 'js-visually-impaired-off',
            setting: 'js-vi-setting',
            settings_revert: 'js-vi-settings-revert'
        };
        
        that.classes_available = [
            'vi-font-large',
            'vi-font-extra-large',
            'vi-images-hidden',
            'vi-filter-grayscale',
            'vi-filter-invert'
        ];
        
        // DYNAMIC VARS
        that.classes_selected = [];
        
        // INIT
        that.init();
    };

    visuallyImpairedSettings.prototype.init = function () {
        var that = this;
        
        that.__initDrawer();
        that.__initAbilityTurnOff();
    };

    visuallyImpairedSettings.prototype.__initDrawer = function () {
        var that = this;

        $.sa.$document.on('click', '.' + that.class.switch_on, function (e){
            e.preventDefault();
            that.__renderDrawer();
        });
    };

    visuallyImpairedSettings.prototype.__initAbilityTurnOff = function () {
        var that = this;

        $.sa.$document.on('click', '.' + that.class.switch_off, function (e) {
            e.preventDefault();
            that.__removeHtmlClasses();
            that.__clearSettingsData();
            that.__switchButtonToggle();
        });
    };

    visuallyImpairedSettings.prototype.__renderDrawer = function () {
        var that = this;

        $.uiDrawer({
            size: 'small',
            position: 'right',
            html: that.drawer_html,
            onOpen: function ($drawer) {
                 that.__onSettingsOpen($drawer);
            },
            onButtonConfirmClick: function () {
                that.__onSettingsConfirm();
            },
            onButtonCancelClick: function () {
                that.__onSettingsCancel();
            },
            onBgClick: function () {
                that.__onSettingsCancel();
            }
        });
    };
    
    // EVENT HANDLERS
    visuallyImpairedSettings.prototype.__onSettingsOpen = function ($drawer) {
        var that = this;

        that.classes_selected = [];
        
        that.__collectClassesSelected($drawer);
        that.__removeHtmlClasses();
        that.__workupHtmlClasses();
        that.__switchButtonToggle();
        that.__onSettingsChange($drawer);
        that.__revertButtonInit($drawer);
    };

    visuallyImpairedSettings.prototype.__onSettingsConfirm = function () {
        var that = this;
        
        that.__saveSettingsData();
        that.__switchButtonToggle();
    };

    visuallyImpairedSettings.prototype.__onSettingsCancel = function () {
        var that = this;
        
        that.classes_selected = [];
        
        that.__removeHtmlClasses();
        that.__switchButtonToggle();
    };

    visuallyImpairedSettings.prototype.__onSettingsChange = function ($drawer) {
        var that = this,
            $setting = $drawer.find('.' + that.class.setting);

        $setting.on('change', function (e){
            that.__collectClassesSelected($drawer);
            that.__removeHtmlClasses();
            that.__workupHtmlClasses();
            that.__switchButtonToggle();
        });
    };

    // SETTINGS MANIPULATION
    visuallyImpairedSettings.prototype.__collectClassesSelected = function ($drawer) {
        var that = this;

        that.classes_selected = [];
        
        $drawer.find('.' + that.class.setting).filter(':checked').each(function (){
            var $this = $(this);

            if ($this.val()) {
                that.classes_selected.push($this.val());
            }
        });
    };

    visuallyImpairedSettings.prototype.__revertButtonInit = function ($drawer) {
        var that = this,
            $button_restore = $drawer.find('.' + that.class.settings_revert);

        $button_restore.on('click', function (e) {
           e.preventDefault();
           that.__revertSettings($drawer);
        });
    };

    visuallyImpairedSettings.prototype.__revertSettings = function ($drawer) {
        var that = this;

        $drawer.find('.' + that.class.setting).each(function (){
            var $this = $(this);

            if (!$this.val()) {
                $this.prop('checked', true).change();
            }
        });
    };

    // STORE SETTINGS
    visuallyImpairedSettings.prototype.__saveSettingsData = function () {
        var that = this;

        if (!!that.classes_selected.length) {
            that.__cookieSet();
        } else {
            that.__cookieDelete();
        }
    };

    visuallyImpairedSettings.prototype.__clearSettingsData = function () {
        var that = this;

        that.__cookieDelete();
        that.classes_selected = [];
    };
    
    visuallyImpairedSettings.prototype.__cookieSet = function () {
        var that = this,
            cookie_value = that.classes_selected.join(' ');
        
        $.sa.setCookie(that.cookie_name, cookie_value, '/', 365);
    };
    
    visuallyImpairedSettings.prototype.__cookieDelete = function () {
        var that = this;
        
        $.sa.setCookie(that.cookie_name, '', '/', 0);
    };

    // HTML MANIPULATION
    visuallyImpairedSettings.prototype.__removeHtmlClasses = function () {
        var that = this;
        
        that.classes_available.forEach(function (class_name) {
            that.$html.removeClass(class_name);
        });
    };

    visuallyImpairedSettings.prototype.__workupHtmlClasses = function () {
        var that = this;

        if (!!that.classes_selected.length) {
            that.classes_selected.forEach(function (class_name) {
                that.$html.addClass(class_name);
            });
        }
        that.__drawerResize();
    };

    visuallyImpairedSettings.prototype.__switchButtonToggle = function () {
        var that = this;

        if (!!that.classes_selected.length) {
            $.sa.$document.find('.' + that.class.switch_on).hide();
            $.sa.$document.find('.' + that.class.switch_off).show();
        } else {
            $.sa.$document.find('.' + that.class.switch_on).show();
            $.sa.$document.find('.' + that.class.switch_off).hide();
        }
    };
    
    // HELPERS
    visuallyImpairedSettings.prototype.__drawerResize = function () {
        var that = this,
            $drawer_scroll_content = $.sa.$document.find('.drawer.visually-impaired-settings .drawer-content.scrollbar.scroll-content') || null;
        
        if (!!$drawer_scroll_content.length) {
            var node_position = $drawer_scroll_content.scrollTop();
            
            setTimeout(function (){
                $.sa.$window.trigger('resize');
                $drawer_scroll_content.scrollTop(node_position);
            }, 1);
        }
    };

    return visuallyImpairedSettings;

})($);
